<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">
				<div class="flex xs-middle">
					<j-button
						size="small"
						type="secondary"
						@click="$router.back()"
						class="mr2"
					>
						<crm-icon name="back" size="normal" color="c5" class="mr1" />
					</j-button>
					{{ $t("template_assets") }}
				</div>
			</template>
		</core-layout-headline-and-actions>
		<core-files-card
			filesOf="templateAssets"
			:list="computedList"
			:canWrite="canWriteFiles"
			@file:deleted="fetchFiles"
			@files:uploaded="fetchFiles"
		/>
	</core-layout-content>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import CoreFilesCard from "@/modules/core/components/CoreFilesCard"
import JButton from "@/components/JButton/"
import CrmIcon from "@/components/CrmIcon/"
import { can } from "@/permissions"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreFilesCard,
		JButton,
		CrmIcon
	},

	data() {
		return {
			list: []
		}
	},

	methods: {
		async fetchFiles() {
			const output = []
			const query = gql`
				query fetchFiles {
					fileListing(prefix: "templates/assets/") {
						objectSummaries {
							fileName
							key
						}
					}
				}
			`
			const variables = null
			const res = await api({ query, variables })
			this.list = res?.data?.fileListing?.objectSummaries
		}
	},

	computed: {
		computedList() {
			return this.list
		},

		canWriteFiles() {
			return can("writeFiles")
		}
	},

	created() {
		this.fetchFiles()
	}
}
</script>
